import { createContext, use } from 'react';
import invariant from 'tiny-invariant';

import type { DocumentFormLine } from '../../types';

export const LineContext = createContext<{
  isMobile: boolean;
  isProductLine: boolean;
  line: DocumentFormLine & { id: string };
  lineFieldName: `sections.${number}.lines.${number}`;
  lineIndex: number;
} | null>(null);

export const useLineContext = () => {
  const context = use(LineContext);

  invariant(context, 'Line components must be wrapped in <SectionLines />');

  return context;
};
